# Theme variables injected by gulp
THEME_NAME = 'bogen'
angular.module('app.controllers').controller 'BoothsCtrl', [
  '$scope', '$rootScope', 'UI'
].append (self, root, UI) ->  
  
  self.exhibitor = ''
  self.booths = []

  self.$on 'onBoothModalOpen', (event, data) ->
    self.exhibitor = data.details
    self.booths = data.boothes
    self.boothsModal.show()

  self.boothsModalEl = document.getElementById('boothsModal')

  if self.boothsModalEl
    self.boothsModal = bootstrap.Modal.getOrCreateInstance(self.boothsModalEl)
  
    self.boothsModalEl.addEventListener('hidden.bs.modal', (event) ->
      self.exhibitor = ''
      self.booths = []
      self.$applyAsync()
    )

    self.boothsModalEl.addEventListener('shown.bs.modal', (event) ->
      self.$applyAsync()
    )